{
  "AboutPage": {
    "get-listed-description": "Kei te hiahia koe ki te whakaatu i tō pakihi ki te Trust Marketplace?",
    "get-listed-suffix": "hei tīmata.",
    "get-listed-title": "Whakauruhia ki te Rārangi",
    "how-description": "Mā te tūāpapa Raytio ka manatokohia e ngā kaihokohoko me ngā tāngata takitahi ō rātou tuakiri, rēhitatanga pakihi, me ngā tohu tuakiri. Ka hainatia matihiko ia manatoko, ā, ka taea te arotake motuhake, e whakarato ana i tētahi mekameka whakawhirinaki mārama.",
    "how-title": "Te Mahi a te Manatoko",
    "sign-up": "Rēhita mō Raytio",
    "title": "Mō te Mākete Whakawhirinaki",
    "what-is-description": "He rārangi ingoa tūmatanui a Raytio Trust Marketplace mō ngā kaihokohoko me ngā kaiwhakarato ratonga kua manatokohia. Ka tautokona ia rārangi e te manatoko whakamuna, kia tika ai, kia pono ai hoki ngā mōhiohio e kitea ana e koe.",
    "what-is-title": "He aha te Mākete Whakawhirinaki?"
  },
  "BookingPage": {
    "book": "Pukapuka",
    "date-range-label": "Panuku",
    "days-label": "ngā rā",
    "km-away": "{tawhiti} kiromita te tawhiti",
    "location-label": "Tauwāhi",
    "location-placeholder": "Whakauruhia te tāone iti, te tāone nui rānei...",
    "no-results": "Kāore i kitea he wā hui. Whakanuia tō rohe rapu, tō awhe rā rānei.",
    "progress": "Kua {oti} te rapunga o {te katoa} ngā kaiwhakarato",
    "radius-label": "I roto",
    "search": "Rapu",
    "search-failed": "I rahua te rapu. Ngāna anō.",
    "search-timed-out": "Kua pau te wā rapu. Kāore pea ētahi kaiwhakarato i whakautu mai.",
    "searching": "Te rapu i ngā kaiwhakarato...",
    "service-label": "Ratonga",
    "service-placeholder": "Tīpakohia he ratonga...",
    "sign-in-prompt": "Waitohu mai ki tō pūkete Raytio hei rapu i ngā wā whakarite e wātea ana.",
    "sign-in-to-search": "Takiuru ki te rapu",
    "sort-closest": "Tata rawa",
    "sort-provider": "Nā te Kaiwhakarato",
    "sort-soonest": "I te wā poto rawa",
    "title": "Whakaritea he Wā Whakarite",
    "location-permission-denied": "Kua whakakāhoretia te whakaaetanga tauwāhi. Tāurua mai he wāhitau kē.",
    "location-unavailable": "Kāore i taea te whakatau i tō tauwāhi. Tāurua mai he wāhitau kē.",
    "my-location": "Taku tauwāhi",
    "use-my-location": "Whakamahia taku tauwāhi",
    "sign-up-prompt": "Kāore koe he pūkete? Waitohu ake ki te rapu i ngā wā wātea.",
    "sign-up-to-search": "Waitohu ake ki te rapu",
    "view-list": "List",
    "view-calendar": "Calendar"
  },
  "CategoryFilter": {
    "clear": "Clear",
    "no-results": "No categories found",
    "placeholder": "Filter by category…"
  },
  "CountryFilter": {
    "all-countries": "Ngā whenua katoa",
    "filter-by-country": "Tātarihia mā te whenua"
  },
  "CtaBar": {
    "book": "Pukapuka",
    "coming-soon": "Kei te haere mai"
  },
  "Footer": {
    "about": "Mō",
    "powered-by": "Whakakahangia e",
    "privacy": "tūmataitinga",
    "terms": "Ngā Ture"
  },
  "Header": {
    "about": "Mō",
    "brand": "Te Mākete o Raytio",
    "merchants": "Ngā kaihokohoko",
    "services": "Ngā Ratonga",
    "sign-in": "Takiuru",
    "sign-out": "Waitohu atu",
    "sign-up": "Waitohu ake"
  },
  "HomePage": {
    "subtitle": "Kimihia ngā kaihokohoko kua manatokohia me ngā kaiwhakarato ratonga pono.",
    "title": "Mākete Whakawhirinaki",
    "verified-merchants": "Ngā Kaihokohoko Kua Manatokohia",
    "view-all": "Tirohia katoa"
  },
  "MerchantCard": {
    "unnamed": "Kaihokohoko Kore Ingoa",
    "verified": "Kua Manatokohia"
  },
  "MerchantDetail": {
    "active": "Hohe",
    "approved": "Kua whakaaetia",
    "default-description": "Tirohia tēnei kaihokohoko i runga i te Raytio Trust Marketplace.",
    "forms-heading": "Ngā Puka",
    "forms-sign-in-button": "Takiuru ki te tiro i ngā puka",
    "forms-sign-in-prompt": "Waitohu mai ki tō pūkete Raytio hei tiro i ngā puka a tēnei kaihokohoko.",
    "locations": "Ngā Wāhi",
    "no-address": "Kāore he wāhitau e wātea ana",
    "no-forms-available": "Kāore he puka e wātea ana",
    "not-found": "Kāore i Kitea te Kaihokohoko",
    "primary-use": "Tuatahi",
    "sign-in-prompt": "Waitohu mai ki tō pūkete Raytio kia kite i ngā taipitopito o te peka me ngā tauwāhi mō tēnei kaihokohoko.",
    "sign-in-to-view": "Takiuru ki te tiro i ngā wāhi",
    "unnamed": "Kaihokohoko Kore Ingoa",
    "forms-sign-up-button": "Waitohu ake kia kite i ngā puka",
    "forms-sign-up-prompt": "Kāore koe he pūkete? Waitohu ake ki te whai wāhi ki ngā puka o tēnei kaihoko."
  },
  "MerchantsPage": {
    "no-merchants": "Kāore he kaihokohoko i kitea.",
    "subtitle": "Tirotirohia ngā kaihokohoko kua manatokohia me ngā kaiwhakarato ratonga pono.",
    "title": "Rarangi Kaihokohoko"
  },
  "SearchBar": {
    "placeholder": "Rapua ngā kaihokohoko..."
  },
  "ServiceCategoryFilter": {
    "no-results": "Kāore i kitea he kāwai",
    "placeholder": "Peke atu ki tētahi kāwai ratonga…"
  },
  "ServiceCategoryPage": {
    "breadcrumb-services": "Ngā Ratonga",
    "no-merchants": "Kāore i kitea he kaiwhakarato mō tēnei ratonga.",
    "not-found": "Kāore i Kitea te Ratonga",
    "search-placeholder": "Ngā kaiwhakarato rapu...",
    "sign-in-prompt": "Waitohu mai ki tō pūkete Raytio kia kite i ngā kaiwhakarato mō tēnei ratonga.",
    "sign-in-to-view": "Takiuru ki te tiro i ngā kaiwhakarato",
    "sign-up-prompt": "Kāore koe he pūkete? Waitohu ake ki te kite i ngā kaiwhakarato mō tēnei ratonga.",
    "sign-up-to-view": "Waitohu ake kia kite i ngā kaiwhakarato"
  },
  "ServiceItemAttributes": {
    "no-data": "Kāore he raraunga huanga e wātea ana."
  },
  "ServiceMerchantPage": {
    "breadcrumb-services": "Ngā Ratonga",
    "hide-details": "Hunaia ngā taipitopito",
    "items-title": "Ngā Hua me ngā Ratonga",
    "no-items": "Kāore he hua, he ratonga rānei kua rārangihia.",
    "not-found": "Kāore i Kitea",
    "show-details": "Whakaatuhia ngā taipitopito"
  },
  "ServicesPage": {
    "no-services": "Kāore he ratonga e wātea ana.",
    "services-count": "{count, plural, one {# ratonga} other {# ratonga}}",
    "subtitle": "Tirotirohia ngā ratonga mā te kāwai.",
    "title": "Ngā Ratonga"
  },
  "ThemeToggle": {
    "dark-mode": "Huri ki te aratau pōuri",
    "light-mode": "Huri ki te aratau mārama"
  },
  "Persona": {
    "issued": "Issued",
    "expires": "Expires",
    "last-verified": "Last verified",
    "self-asserted-note": "Name and bio are self-asserted and unverified",
    "profile-url": "Profile",
    "claim-verification": "Verification",
    "claim-reputation": "Reputation",
    "section-verifications": "Verifications",
    "section-social": "Connected Accounts",
    "section-reputation": "Reputation",
    "section-other": "Other Claims",
    "no-claims": "This profile has no published claims yet.",
    "rating": "Rating",
    "activity": "Activity",
    "member-since": "Member since",
    "not-found-title": "Profile Not Found",
    "not-found-description": "The requested profile could not be found.",
    "canonical-payload": "Raraunga kua hainatia",
    "signature": "Waitohu",
    "signing-key": "Kī waitohu",
    "verify": "Manatoko i te waitohu",
    "verifying": "E manatoko ana…",
    "verify-valid": "He whaimana te waitohu",
    "verify-invalid": "Kāore te waitohu e ōrite",
    "verify-no-key": "Kāore he kī waitohu i tuhia — kāore e taea te manatoko",
    "verify-error": "Kāore i taea te tiki i te kī waitohu",
    "signed": "Signed",
    "verified": "Verified",
    "view-signed-data": "View signed data",
    "hide-signed-data": "Hide signed data",
    "verify-again": "Verify again",
    "try-again": "Try again",
    "verify-valid-detail": "Checked in your browser against Raytio's published key.",
    "verify-valid-caveat": "A valid signature proves Raytio asserted this — not that it is true or complete.",
    "verify-invalid-detail": "This claim may have been altered.",
    "trust-note": "Each signed claim below carries an RSA-PSS signature from Raytio. Expand one to read the exact bytes that were signed and check them in your own browser — you don't have to take this page's word for anything.",
    "attested-claims-title": "Attested claims",
    "claims-summary": "{count, plural, one {# signed by Raytio · check it yourself} other {# signed by Raytio · check any of them yourself}}",
    "open-profile": "Open profile",
    "trust-note-label": "About attested claims",
    "reputation-note": "Bucketed on purpose — Raytio never publishes exact counts.",
    "stat-activity": "Activity",
    "stat-as-buyer": "As buyer",
    "stat-as-seller": "As seller",
    "stat-reviews": "Reviews",
    "stat-none-yet": "None yet",
    "reputation-note-label": "About these figures"
  },
  "Calendar": {
    "day": "Day",
    "week": "Week",
    "month": "Month",
    "today": "Today",
    "prev": "Previous",
    "next": "Next",
    "all": "All",
    "book": "Book",
    "close": "Close",
    "move": "Move detail window",
    "move-reset": "Move detail window (double-click to snap back)",
    "no-slots-day": "No available slots for this day.",
    "more-slots": "+{count} more",
    "slot-count": "{count, plural, one {# slot} other {# slots}}"
  },
  "BuyPage": {
    "title": "Kōwhiria tō wāhanga",
    "slot-label": "Wāhi {slotNumber}",
    "choose-duration": "Tīpakohia he roanga",
    "in-use-title": "Kei te whakamahia tēnei wāhi",
    "in-use-body": "He wāhanga hohe tō tēnei wāhi ināianei. Tēnā, hoki mai ā muri tata nei.",
    "halted-title": "Kei te haere tonu te hoko",
    "halted-body": "Kei te whakaoti tētahi i tētahi hoko mō tēnei wāhi. Tēnā, tatari mō te wā poto ka ngana anō.",
    "no-options": "Kāore he kōwhiringa e wātea ana mō tēnei wāhi."
  }
}
